import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { SessionProfile } from '../../models/smartclock/session.model';
import { AccessService } from '../access/access.service';
import { SessionService } from '../smartclock/session.service';
import { TokenService } from './token.service';

/**
 * Arranque de la sesión: `GET /auth/me` y DESPUÉS (encadenado, no en paralelo)
 * `GET /access/me` (contrato §6). Se usa al iniciar la app con una sesión
 * guardada, tras el login (normal y fiscalizador), tras canjear el claim del
 * signup y tras el cambio de contexto. El refresh de token NO pasa por acá:
 * renovar el token no cambia los permisos.
 */
@Injectable({ providedIn: 'root' })
export class SessionBootstrapService {
  private readonly session = inject(SessionService);
  private readonly access = inject(AccessService);
  private readonly tokens = inject(TokenService);

  /** ¿Hay una sesión guardada que valga la pena restaurar al iniciar? */
  hasStoredSession(): boolean {
    return (
      this.session.current !== null &&
      (this.tokens.hasValidAccessToken() || this.tokens.hasValidRefreshToken())
    );
  }

  /** Perfil y luego permisos. Emite el perfil cuando ambos terminaron. */
  load(): Observable<SessionProfile | null> {
    return this.session
      .loadProfile()
      .pipe(switchMap((profile) => this.access.load({ force: true }).pipe(map(() => profile))));
  }
}
